import {
  CLAIMLINE_LOADING,
  CLAIMLINE_SUCCESS,
  CLAIMLINE_FAILED
} from '../actions/claimLineActions'

const ClaimLines = (state = {}, action) => {
  switch (action.type) {
    case CLAIMLINE_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        claimLines: null,
        error: null
      })
    case CLAIMLINE_SUCCESS:
      return Object.assign({}, state, {
        claimLines: action.response,
        error: null,
        isLoading: false
      })
    case CLAIMLINE_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        claimLines: null,
        isLoading: false
      })
    default:
      return state
  }
}
export default ClaimLines



// WEBPACK FOOTER //
// ./src/redux/reducers/claimLineReducer.js